import MenuPage from 'apps/Diner/MenuPage/MenuPage'
import DinerContainer from 'apps/Diner/DinerApp/DinerContainer'

const MenuPageContainer = (): JSX.Element => {
  return <MenuPage />
}

MenuPageContainer.getLayout = (page: JSX.Element) => {
  return <DinerContainer>{page}</DinerContainer>
}

export default MenuPageContainer
